import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrontendKeyboardService } from './frontend-keyboard.service';

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [FrontendKeyboardService],
})
export class FrontendKeyboardModule { }
